import React, { useState, useEffect } from "react";
import classNames from "classnames";

const styles = {
  root: {
    position: "absolute",
    width: "100%",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 2,
    cursor: "pointer",
    marginTop: "31px",
  },
  notAvailableText: {
    display: "flex",
    justifyContent: "center",
    color: "white",
    fontSize: "larger",
    "& > h6": {
      fontWeight: "600",
      letterSpacing: "1.1px !important",
    },
  },
};

export default ({
  closeDailog,
  setWebCamData,
  selectedType,
  showSelectors,
}) => {
  const classes = styles;
  const [webCamAvailable, setWebCamAvailable] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        await navigator.mediaDevices.getUserMedia({
          video: true,
        });

        updateDeviceList();
      } catch (e) {
        console.log(e);
        setWebCamAvailable(false);
      }
    })();
    //eslint-disable-next-line
  }, []);

  navigator.mediaDevices.ondevicechange = function (event) {
    updateDeviceList();
  };

  function updateDeviceList() {
    navigator.mediaDevices.enumerateDevices().then(function (devices) {
      var result = devices.some((device) => device.kind === "videoinput");
      if (result) {
        setWebCamAvailable(true);
        return;
      }
      if (closeDailog) {
        setWebCamData();
        closeDailog();
      }
      setWebCamAvailable(false);
    });
  }

  return (
    <>
      {!webCamAvailable && ["video", "image"].includes(selectedType) && (
        <div
          style={classes.root}
          className={classNames({
            webCameraNoSelectorOverlayHeight: showSelectors ? true : false,
            webCameraSelectorOverlayHeight: !showSelectors ? true : false,
          })}
        >
          <div style={classes.notAvailableText}>
            <h6>Your web camera is not available kindly turn it on</h6>
          </div>
        </div>
      )}
    </>
  );
};
